import { Component, inject } from '@angular/core';
import { ListViewProviderDirective, NtapGlobalConstants } from '@ntap/core';
import { first, tap } from 'rxjs';

@Component({
  selector: `app-odabir-povezanog-primatelja`,
  templateUrl: './odabir-povezanog-primatelja.component.html'
})
export class OdabirPovezanogPrimateljaComponent {
  public showDialog = false;

  private listviewProvider = inject(ListViewProviderDirective);

  public refresh() {
    this.listviewProvider.refresh();
  }

  public onSelectedItem(primatelji: any[]) {
    let id = 0;
    this.listviewProvider.view$
      .pipe(
        first(),
        tap((view) => {
          const parentJedinicaGradivaId = (
            this.listviewProvider.viewState as {
              'en~jedinica_gradiva~id': number;
            }
          )['en~jedinica_gradiva~id'];

          const posiljkaId = (
            this.listviewProvider.viewState as {
              'seup~posiljka~id': number;
            }
          )['seup~posiljka~id'];

          primatelji.forEach((primatelj) => {
            const naziv: string = this.getNazivFromPrimatelj(primatelj);
            const newItem: any = {
              'sv~posiljka_primatelj~id': id,
              'sv~posiljka_primatelj~naziv_primatelja': naziv,
              'sv~posiljka_primatelj~drzava': primatelj['seup~subjekt~drzava'],
              'sv~posiljka_primatelj~mjesto': primatelj['seup~subjekt~mjesto'],
              'sv~posiljka_primatelj~ulica': primatelj['seup~subjekt~ulica'],
              'sv~posiljka_primatelj~email_address':
                primatelj['seup~subjekt~email_adress'],
              'sv~posiljka_primatelj~edelivery_address':
                primatelj['seup~subjekt~edelivery_adress'],
              'sv~posiljka_primatelj~original_subjekt_id':
                primatelj['seup~subjekt~id']
            };

            const updateItem: any = {
              'sv~posiljka_primatelj~id': id,
              'sv~posiljka_primatelj~entitet_id': parentJedinicaGradivaId,
              'sv~posiljka_primatelj~posiljka_id': posiljkaId,
              'sv~posiljka_primatelj~naziv_primatelja': naziv,
              'sv~posiljka_primatelj~drzava': primatelj['seup~subjekt~drzava'],
              'sv~posiljka_primatelj~ulica': primatelj['seup~subjekt~ulica'],
              'sv~posiljka_primatelj~mjesto': primatelj['seup~subjekt~mjesto'],
              'sv~posiljka_primatelj~email_address':
                primatelj['seup~subjekt~email_adress'],
              'sv~posiljka_primatelj~edelivery_address':
                primatelj['seup~subjekt~edelivery_adress'],
              'sv~posiljka_primatelj~original_subjekt_id':
                primatelj['seup~subjekt~id'],
              $itemType: 'sv~posiljka_primatelj'
            };

            id--;
            newItem[NtapGlobalConstants.ATTR_$itemType] = view.$mainType;
            this.listviewProvider.addItem(newItem);
            this.listviewProvider.updateItem(updateItem, 0);
          });
        })
      )
      .subscribe();

    this.showDialog = false;
  }

  getNazivFromPrimatelj(primatelj: any): string {
    let naziv = '';
    if (primatelj['seup~subjekt~naziv']) {
      naziv = primatelj['seup~subjekt~naziv'];
    } else if (
      !!primatelj['seup~subjekt~ime'] &&
      !!primatelj['seup~subjekt~prezime']
    ) {
      naziv =
        primatelj['seup~subjekt~ime'] + ' ' + primatelj['seup~subjekt~prezime'];
    } else {
      naziv = '';
    }
    return naziv;
  }
}
